import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ApiEditingToolFoundMember } from 'sc-common/core/services/open-api/main-api-client';

@Component({
    selector: 'et-search-member',
    templateUrl: './search-member.component.html',
    standalone: false
})
export class SearchMemberComponent {

    @Input()
    public members: ApiEditingToolFoundMember[];

    @Input()
    public emptyMessage: string;

    @Output()
    public readonly filter = new EventEmitter<string>();

    @Output()
    public readonly selectItem = new EventEmitter<ApiEditingToolFoundMember>();

    public completeMethod(event: { query: string; }): void {
        if (!event.query) {
            return;
        }

        this.filter.next(event.query);
    }

    public onSelect(member: ApiEditingToolFoundMember): void {
        this.selectItem.next(member);
    }
}
